import useThunkDispatch from 'common/hooks/useThunkDispatch';
import useTypedSelector from 'common/hooks/useTypedSelector';
import FetchStatus from 'common/types/FetchStatus';
import { fetchSubmittedApplications } from 'features/account-dashboard/ApplicationsSlice';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ApplicationTable from './ApplicationTable';
import { FormCheck } from 'react-bootstrap';

function ApplicationTableContainer(props: { hideOnEmpty?: boolean }) {
  const [rowsToHide, setRowsToHide] = useState<number[]>([]);
  const [hideRows, setHideRows] = useState(false);
  const { applications, meta } = useTypedSelector((state) => ({
    name: state.profile.data.firstName,
    applications: state.applications,
    meta: state.applications.meta,
  }));
  const dispatch = useThunkDispatch();

  useEffect(() => {
    dispatch(
      fetchSubmittedApplications({
        pageNum: meta.pagination.currentPage,
        pageSize: meta.pagination.itemsPerPage,
        sortBy: meta.sortBy,
        sortDir: meta.sortDir,
      })
    );
  }, [dispatch]);

  const handlePageChange = (page: number, size: number) => {
    dispatch(
      fetchSubmittedApplications({
        pageNum: page,
        pageSize: size,
        sortBy: meta.sortBy,
        sortDir: meta.sortDir,
      })
    );
  };

  const handleSort = (sortBy: string, sortDir: string) => {
    dispatch(
      fetchSubmittedApplications({
        pageNum: 0,
        pageSize: meta.pagination.itemsPerPage,
        sortBy: sortBy,
        sortDir: sortDir,
      })
    );
  };

  if (props.hideOnEmpty && applications.meta.currentPageIds.length <= 0) {
    return (
      <>
        <h3 className='mt-3'>My Applications</h3>
        <p>
          Before you can start an application, you will need to complete your
          profile and/or verify your identification.
        </p>
        <Link className='btn btn-primary' to='/apply-for-registration'>
          Apply for a Registration Number
        </Link>
      </>
    );
  }
  const mappedData = applications.meta.currentPageIds.map(
    (id) => applications.entities[id]
  );

  return (
    <>
      <div className='d-flex justify-content-sm-between align-items-lg-center'>
        <h3 className='mt-3'>My Applications</h3>
        {rowsToHide.length > 0 && (
          <div className='d-flex'>
            <FormCheck
              onChange={() => {
                setHideRows((prev) => !prev);
              }}
            />
            <span className='pl-3'>Hide selected rows</span>
          </div>
        )}
      </div>

      <ApplicationTable
        data={
          hideRows
            ? mappedData.filter(
                (application) => !rowsToHide.includes(application.id)
              )
            : mappedData
        }
        onSort={handleSort}
        onSelect={(_, __, selectedRows) => {
          setRowsToHide(selectedRows);
        }}
        pagination={{
          totalPages: applications.meta.pagination.totalPages,
          totalCount: applications.meta.pagination.totalCount,
          currentPage: applications.meta.pagination.currentPage,
          itemsPerPage: applications.meta.pagination.itemsPerPage,
          onPageChange: handlePageChange,
          loading: applications.meta.fetchStatus === FetchStatus.loading,
        }}
      />
      <Link className='btn btn-primary' to='/apply-for-registration'>
        Apply for a Registration Number
      </Link>
    </>
  );
}

export default ApplicationTableContainer;
